<template>
  <div class="container" id="faq">
    <div class="d-flex flex-column m-auto">
      <header>
        <h2>PERGUNTAS FREQUENTES</h2>
      </header>
      <div class="d-flex justify-content-center">
        <ul class="faq list-group">
          <li
            class="list-group-item border-bottom"
            v-for="(item, i) in items"
            :key="i"
          >
            <b-btn
              block
              v-b-toggle="'collapse' + i"
              variant="transparent"
              class="text-left d-flex font-sans-serif-regular item-title"
            >
              <img class="add" src="@/assets/images/add.svg" alt="" />
              {{ item.title }}
            </b-btn>

            <b-collapse
              :id="'collapse' + i"
              accordion="faq-accordion"
              role="tabpanel"
            >
              <b-card class="border-0">
                <div
                  v-html="item.content"
                  class="item-content"
                  @click="triggerLinks"
                ></div>
              </b-card>
            </b-collapse>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Faq",

  computed: {
    faqObject() {
      return this.$store.state.faq;
    },
    items() {
      return this.$store.state.faqItems || [];
    },
  },
  components: {},
  methods: {
    triggerLinks() {
      if (event.target.nodeName == "A" && event.target.target != "_blank") {
        event.preventDefault();
        let to = event.target.href.split(event.target.host);
        this.$router.push(to[1]);
      }
    },
    deviseForm() {
      console.log("opa");
    },
  },
};
</script>

<style scoped lang="scss">
.add {
  width: 28px;
  margin-right: 0.5rem;
  @include media-breakpoint-down(sm) {
    width: 20px;
  }
}

h2 {
  margin-bottom: 1rem;
  margin-top: 6.5rem;
}

.faq {
  border-radius: 0;
  overflow: hidden;
  color: #486072;
  width: 100%;
  margin: auto;

  .item-title {
    color: #000;
    font-weight: 400 !important;
    font-size: 1.12rem;
      font-family: 'Proxima Nova Rg';
    text-transform: uppercase;
    letter-spacing: 2px;
    @include media-breakpoint-down(sm) {
      font-size: 1rem;
    }
  }

  .btn {
    white-space: normal;
    border-radius: 0;
    align-items: center;
    &[aria-expanded="true"] {
      .arrow-down {
        transform: rotate(-180deg);
      }
    }
  }

  .svg-collapse {
    margin-right: 12px;
  }
  .card-body {
    background-color: theme-color(medium);
  }
  .item-content {
    font-size: 1.2rem;
    font-weight: 500;
    @include media-breakpoint-down(sm) {
      font-size: 1rem;
    }
  }
  .list-group-item {
    padding: 0;
    border-radius: 0;
    border: none !important;
    // border-width: 2px !important;
    color: #000;
    border-bottom: 1px solid rgba(#000, 0.25) !important;
    .btn {
      padding: 2rem 0px;
      border-radius: 0;
      border-bottom: none;
      background-color: theme-color(medium);
    }
  }
}
</style>
